export default {
  employees: '',
  birthdays: '',
  contactMessagesWebSite: '',
  paychecks: '',
  employee_scales: '',
  income_taxes: '',
}
